module.exports = __webpack_public_path__ + "img/icone-coa-real-time.5551f90e.svg";